if (!customElements.get('gabriel-jewelry-rail')) {
  customElements.define('gabriel-jewelry-rail', class extends HTMLElement {
    connectedCallback() {
      this.track = this.querySelector('.ga-discovery-track');
      this.controls = this.querySelector('.ga-discovery-controls');
      if (!this.track || !this.controls) return;
      this.previous = this.querySelector('[data-direction="previous"]');
      this.next = this.querySelector('[data-direction="next"]');
      this.count = this.querySelector('.ga-discovery-count');
      this.status = this.querySelector('.ga-discovery-status');
      this.motion = window.matchMedia('(prefers-reduced-motion: reduce)');
      this.events = new AbortController();
      const options = { signal: this.events.signal };
      this.previous.addEventListener('click', () => this.move(-1), options);
      this.next.addEventListener('click', () => this.move(1), options);
      this.track.addEventListener('scroll', () => {
        if (!this.frame) this.frame = requestAnimationFrame(() => { this.frame = null; this.update(); });
        clearTimeout(this.announceTimer);
        this.announceTimer = setTimeout(() => this.announce(), 200);
      }, { ...options, passive: true });
      this.track.addEventListener('keydown', event => {
        if (event.target !== this.track) return;
        if (event.key === 'ArrowRight' || event.key === 'ArrowLeft') {
          event.preventDefault();
          this.move(event.key === 'ArrowRight' ? 1 : -1);
        } else if (event.key === 'Home' || event.key === 'End') {
          event.preventDefault();
          this.scrollTo(event.key === 'Home' ? 0 : this.track.scrollWidth);
        }
      }, options);
      this.resize = new ResizeObserver(() => this.update());
      this.resize.observe(this.track);
      this.update();
    }
    disconnectedCallback() {
      this.events?.abort();
      this.resize?.disconnect();
      cancelAnimationFrame(this.frame);
      clearTimeout(this.announceTimer);
    }
    scrollTo(left) {
      this.track.scrollTo({ left, behavior: this.motion.matches ? 'instant' : 'smooth' });
    }
    move(direction) {
      const first = this.track.children[0];
      if (!first) return;
      const gap = parseFloat(getComputedStyle(this.track).columnGap) || 0;
      const step = first.getBoundingClientRect().width + gap;
      const index = Math.round(this.track.scrollLeft / step);
      this.scrollTo((index + direction) * step);
    }
    update() {
      const { scrollWidth, clientWidth } = this.track;
      const maximum = Math.max(0, scrollWidth - clientWidth);
      const left = Math.max(0, Math.min(maximum, this.track.scrollLeft));
      this.controls.hidden = maximum < 2;
      this.previous.disabled = left < 2;
      this.next.disabled = maximum - left < 2;
      const size = Math.min(100, clientWidth / Math.max(1, scrollWidth) * 100);
      this.style.setProperty('--ga-progress-size', size + '%');
      this.style.setProperty('--ga-progress-x', (maximum ? left / maximum * (100 - size) : 0) + '%');
      const viewport = this.track.getBoundingClientRect();
      const visible = [...this.track.children].map((item, index) => {
        const rect = item.getBoundingClientRect();
        const overlap = Math.min(viewport.right, rect.right) - Math.max(viewport.left, rect.left);
        return overlap >= rect.width * 0.65 ? index + 1 : null;
      }).filter(Boolean);
      if (!visible.length) return;
      this.firstVisible = visible[0];
      this.lastVisible = visible[visible.length - 1];
      this.total = this.track.children.length;
      this.count.textContent = (this.firstVisible === this.lastVisible ? this.firstVisible : `${this.firstVisible}–${this.lastVisible}`) + ' / ' + this.total;
    }
    announce() {
      if (!this.total) return;
      this.status.textContent = this.dataset.statusTemplate
        .replace('[first]', this.firstVisible).replace('[last]', this.lastVisible).replace('[total]', this.total);
    }
  });
}
